export const SET_TOKEN = 'APP/CORE/SET_TOKEN';
export const SETUP_SIGNALR_CONNECTION = 'APP/CORE/SETUP_SIGNALR_CONNECTION';
export const SET_CONNECTION = 'APP/CORE/SET_CONNECTION';
export const SEND_FEEDBACK = 'APP/CORE/SEND_FEEDBACK';
export const FEEBACK_MODAL = 'APP/CORE/FEEDBACK_MODAL';
export const FEEDBACK_ERROR = 'APP/CORE/FEEDBACK_ERROR';

export const SHOW_FLAG_MODAL = 'APP/CORE/SHOW_FLAG_MODAL';
export const HIDE_FLAG_MODAL = 'APP/CORE/HIDE_FLAG_MODAL';
export const SEND_FLAG = 'APP/CORE/SEND_FLAG';
export const FLAG_SUCCESS = 'APP/CORE/FLAG_SUCCESS';
export const FLAG_ERROR = 'APP/CORE/FLAG_ERROR';

export const SHOW_EDGE_FLAG_MODAL = 'APP/CORE/SHOW_EDGE_FLAG_MODAL';
export const HIDE_EDGE_FLAG_MODAL = 'APP/CORE/HIDE_EDGE_FLAG_MODAL';
export const SEND_EDGE_FLAG = 'APP/CORE/SEND_EDGE_FLAG';
export const EDGE_FLAG_ERROR = 'APP/CORE/EDGE_FLAG_ERROR';

export const RESET_COMPLETE_GRAPH = 'APP/CORE/RESET_COMPLETE_GRAPH';
export const CANCEL_SEARCH = 'APP/CORE/CANCEL_SEARCH';
export const INDIVDUAL_FILTERS = 'APP/CORE/INDIVDUAL_FILTERS';
export const TOGGLE_FAVORITE = 'APP/CORE/TOGGLE_FAVORITE';
export const SET_FAVORITES = 'APP/CORE/SET_FAVORITES';
export const SET_ERROR = 'APP/CORE/SET_ERROR';
export const CLEAR_ERROR = 'APP/CORE/CLEAR_ERROR';

export const SET_SEARCH_MODE = 'APP/CORE/SET_SEARCH_MODE';
export const SET_FILTER_SESSION = 'APP/CORE/SET_FILTER_SESSION';
export const CLEAR_FILTER_SESSION = 'APP/CORE/CLEAR_FILTER_SESSION';
export const EXECUTE_FILTER_SEARCH = 'APP/CORE/EXECUTE_FILTER_SEARCH';